<div id="app" class="app" style="display: flex; flex-direction: column; width: 100%; overflow-x: hidden">
  <router-outlet></router-outlet>
  <div id="app-spinner" [class.hide]="!globalService.loadingSpinner" role="status" aria-live="polite">
    <div
      class="animated-logo-css"
      style="width: 100px; height: 100px; margin-bottom: 15px; margin-top: 15px"
      role="img"
      aria-label="Seguros Virtual"
    ></div>
    <h4 style="text-align: center; color: white; display: flex; flex-direction: column; align-items: center">
      <span style="margin-bottom: 8px">{{ globalService.loadingMessage$ | async }}</span>
      <span
        class="force-white"
        style="
          font-size: 11px;
          opacity: 0.75;
          font-weight: 300;
          text-transform: none;
          letter-spacing: 0;
          line-height: 1.4;
        "
        >{{ 'COMMON.LOADING.SPINNER_TITLE' | translate }}<br />{{ 'COMMON.LOADING.SPINNER_SUBTITLE' | translate }}</span
      >
    </h4>
  </div>
</div>

<!-- Notificação de falha de rede -->
<app-network-status></app-network-status>

<!-- Aviso de Expiração de Sessão -->
<app-session-expiration-warning></app-session-expiration-warning>

<!-- CHATBOT GLOBAL - Movi para aqui para não ser afetado por transform e z-index constraints de rotas -->
<app-chatbot
  *ngIf="globalService.commonDefaultsClass?.UseAI && globalService.commonDefaultsClass?.UseAIChatbot"
  #globalChatbot
></app-chatbot>

<!-- Smiley Help Global -->
<app-smiley [style.display]="globalService.isChatbotOpen ? 'none' : null"></app-smiley>
